// @owners { team: patients-team }
import { createSelector } from 'reselect';
import { getCurrentUser } from './getCurrentUser';

export const getCurrentUserLabels = createSelector(getCurrentUser, (user) => {
  return user?.labels ?? [];
});
